export enum TrackingStates {
  PENDING = 'Pending',
  INFO_RECEIVED = 'Info Received',
  IN_TRANSIT = 'In Transit',
  OUT_FOR_DELIVERY = 'Out for Delivery',
  FAILED_ATTEMPT = 'Failed Attempt',
  DELIVERED = 'Delivered',
  EXCEPTION = 'Exception',
  EXPIRED = 'Expired',
}
